import { ChatPanel } from '@/components/chat/chat-panel'
import { TealBanner } from '@/components/mobile/teal-banner'
import { useIsMobile } from '@/hooks/use-is-mobile'
import { useSessionState } from '@/hooks/use-session-state'
import { useState } from 'react'
import { Navigate } from 'react-router-dom'

export function ChatPage() {
  const isMobile = useIsMobile()
  const { data: sessionState } = useSessionState()
  const [returnBannerDismissed, setReturnBannerDismissed] = useState(
    () => sessionStorage.getItem('returnGreetingDismissed') === 'true',
  )

  if (!isMobile) {
    return <Navigate to="/resume" replace />
  }

  const handleDismissReturn = () => {
    setReturnBannerDismissed(true)
    sessionStorage.setItem('returnGreetingDismissed', 'true')
  }

  const showReturnBanner = sessionState?.emotional_check_in_needed && !returnBannerDismissed

  return (
    <div className="flex flex-col h-full">
      {showReturnBanner && (
        <TealBanner
          position="inline"
          onDismiss={handleDismissReturn}
          actions={[
            { label: 'Continue', onClick: handleDismissReturn },
            {
              label: 'Want to talk',
              onClick: handleDismissReturn,
            },
          ]}
        >
          Welcome back! How are you doing?
        </TealBanner>
      )}
      <ChatPanel className="flex-1 min-h-0" />
    </div>
  )
}
